import { useCallback, useMemo, useState } from 'react';
import { IFilterAllData, ListOfKeysFilterAllData } from 'src/typings/filter';
import { CRMNames, IMessage } from 'src/typings/app';
import { useSelector } from 'react-redux';
import { getBitrixDeal, getCreatioDeal, getNetHuntDeal } from 'src/store/crosstable/selectors';
import { getCrmData } from 'src/store/app/selectors';
import { getSelectedFloor } from 'src/store/floors/selectors';

export const useSelectedDeal = () => {
  const crmData = useSelector(getCrmData);
  const bitrixDeal = useSelector(getBitrixDeal);
  const creatioDeal = useSelector(getCreatioDeal);
  const netHuntDeal = useSelector(getNetHuntDeal);
  const selectedFloorIds = useSelector(getSelectedFloor);
  const [isAnyDealSelected, setIsAnyDealSelected] = useState<boolean>(false);

  const isSelectedDeal = useCallback((fillFloorsItem: IFilterAllData | undefined) => {
    if (fillFloorsItem) {
      const { bitrix_deals: bitrixDeals, netHuntOpportunities, creatioOpportunities } = fillFloorsItem;
      if (crmData?.crm === CRMNames.amocrm) {
        if (fillFloorsItem[ListOfKeysFilterAllData.placementAmoDeals]) {
          fillFloorsItem[ListOfKeysFilterAllData.placementAmoDeals].forEach((item) => {
            setIsAnyDealSelected(true);
            return crmData && item.includes(String(crmData?.dealId));
          });
        }
      } else if (crmData?.crm === CRMNames.bitrix) {
        setIsAnyDealSelected(!!bitrixDeal?.placement);
        // Data-independent match: the deal itself knows its linked unit —
        // compare unit ids. Some projects' spinner payload rows carry NO
        // bitrix_deals arrays at all (per-project backend config), so the
        // array scan below is only a fallback.
        const linkedUnitId = typeof bitrixDeal?.placement === 'string'
          ? (bitrixDeal.placement as string).split('/').filter(Boolean).pop()
          : bitrixDeal?.placement?.id;
        if (linkedUnitId
          && String(fillFloorsItem[ListOfKeysFilterAllData.id]) === String(linkedUnitId)) {
          return true;
        }
        // String-safe match: row deals carry UID string ids while the store deal
        // (or crmData.dealId from the widget message) may hold a numeric id —
        // strict === between the formats never matched after link/unlink.
        const found = bitrixDeals && bitrixDeals.find((item) => {
          if (bitrixDeal && String(item.id) === String(bitrixDeal.id)) return true;
          if (bitrixDeal?.bitrixExternalDealId && item.bitrixExternalDealId
            && String(item.bitrixExternalDealId) === String(bitrixDeal.bitrixExternalDealId)) return true;
          return !!item.bitrixExternalDealId && crmData?.dealId != null
            && String(item.bitrixExternalDealId) === String(crmData.dealId);
        });
        return !!found;
      } else if (crmData?.crm === CRMNames.creatio) {
        return !!(creatioOpportunities && creatioOpportunities.find((item) => creatioDeal && item.id === creatioDeal.id));
      } else if (crmData?.crm === CRMNames.netHunt) {
        return !!(netHuntOpportunities && netHuntOpportunities.find((item) => netHuntDeal && item.id === netHuntDeal.id));
      }
    }
    return false;
  }, [crmData, crmData, creatioDeal, netHuntDeal, bitrixDeal, selectedFloorIds]);
  return {
    isSelectedDeal,
    isAnyDealSelected,
  };
};
